import { render, staticRenderFns } from "./purchase-records-details.vue?vue&type=template&id=5a28bb3c&"
import script from "./purchase-records-details.vue?vue&type=script&lang=js&"
export * from "./purchase-records-details.vue?vue&type=script&lang=js&"
import style0 from "./purchase-records-details.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports